<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint"/>

    <div class="mb-6">
      <p class="title mb-5"><i class="dot"></i>사업장(수급업체) 정보</p>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">사업장명</div>
          <span v-if="isPrint" class="print-input"> {{ form.companyName }} </span>
          <CompanySelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputB_1"
            placeholder="선택"
            @select="targetCompany"
          ></CompanySelector>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">업종 또는 주요 생산품명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_2 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputB_2"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">주소</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_3 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputB_3"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">남성 근로자 수(명)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_4 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputB_4"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">여성 근로자 수(명)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_5 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputB_5"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">총 근로자 수(명)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_6 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputB_6"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">전화번호</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_7 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputB_7"
          />
        </div>
      </div>
    </div>
    <div class="mb-6">
      <p class="title mb-5"><i class="dot"></i>안전관리자(안전관리 전문기관)</p>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">성명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_1 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputC_1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">기관명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_2 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputC_2"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">이메일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_3 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputC_3"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">전화번호</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_4 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputC_4"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">자격/면허번호</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_5 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputC_5"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">경력(기관명)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_6 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputC_6"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">경력(경력기간)</div>
          <span v-if="isPrint" class="print-input"> {{form.inputC_7}} 년 {{form.inputC_8}} 월</span>
          <div v-else class="w-full flex flex-1 items-center">
            <vs-input class="w-auto" v-model="form.inputC_7"/>
            <p class="ml-2 mr-2 text-center">년</p>
            <vs-input class="w-auto" v-model="form.inputC_8"/>
            <p class="ml-2 text-center">월</p>
          </div>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">학력(학교)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_9 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputC_9"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">학력(학과)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_10 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputC_10"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">선임일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_11 }} </span>
          <DateSelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputC_11"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">구분</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_12 }} </span>
          <action-type-division
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputC_12"
          />
        </div>
      </div>
    </div>
    <div class="mb-6">
      <p class="title mb-5"><i class="dot"></i>보건관리자(보건관리 전문기관)</p>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">성명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_1 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputD_1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">기관명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_2 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputD_2"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">이메일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_3 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputD_3"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">전화번호</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_4 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputD_4"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">자격/면허번호</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_5 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputD_5"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">경력(기관명)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_6 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputD_6"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">경력(경력기간)</div>
          <span v-if="isPrint" class="print-input"> {{form.inputD_7}} 년 {{form.inputD_8}} 월</span>
          <div v-else class="w-full flex flex-1 items-center">
            <vs-input class="w-auto" v-model="form.inputD_7"/>
            <p class="ml-2 mr-2 text-center">년</p>
            <vs-input class="w-auto" v-model="form.inputD_8"/>
            <p class="ml-2 text-center">월</p>
          </div>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">학력(학교)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_9 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputD_9"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">학력(학과)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_10 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputD_10"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">선임일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_11 }} </span>
          <DateSelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputD_11"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">구분</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_12 }} </span>
          <action-type-division
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputD_12"
          />
        </div>
      </div>
    </div>
    <div class="mb-6">
      <p class="title mb-5"><i class="dot"></i>산업보건의</p>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">성명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_1 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputE_1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">기관명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_2 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputE_2"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">이메일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_3 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputE_3"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">전화번호</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_4 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputE_4"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">자격/면허번호</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_5 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputE_5"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">경력(기관명)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_6 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputE_6"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">경력(경력기간)</div>
          <span v-if="isPrint" class="print-input"> {{form.inputE_7}} 년 {{form.inputE_8}} 월</span>
          <div v-else class="w-full flex flex-1 items-center">
            <vs-input class="w-auto" v-model="form.inputE_7"/>
            <p class="ml-2 mr-2 text-center">년</p>
            <vs-input class="w-auto" v-model="form.inputE_8"/>
            <p class="ml-2 text-center">월</p>
          </div>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">학력(학교)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_9 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputE_9"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">학력(학과)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_10 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputE_10"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">선임일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_11 }} </span>
          <DateSelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputE_11"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">구분</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_12 }} </span>
          <action-type-division
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputE_12"
          />
        </div>
      </div>
    </div>
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" />
  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import SearchNavStartEnd from '../../../list/components/SearchNavStartEnd.vue'
import FileUploadModule from '../../../modules/FileUploadModule.vue'
import ActionTypeDivision from '../../../../components/selector/ActionTypeDivision.vue'
import FieldSelectModule from '@/views/modules/FieldSelectModule'

export default {
  components: {
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    SearchNavStartEnd,
    FileUploadModule,
    ActionTypeDivision,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      },
    },
  },
  data () {
    return {
      form: {
        stdInfo: {},

        inputB_1: '',
        inputB_2: '',
        inputB_3: '',
        inputB_4: '',
        inputB_5: '',
        inputB_6: '',
        inputB_7: '',

        inputC_1: '',
        inputC_2: '',
        inputC_3: '',
        inputC_4: '',
        inputC_5: '',
        inputC_6: '',
        inputC_7: '',
        inputC_8: '',
        inputC_9: '',
        inputC_10: '',
        inputC_11: '',
        inputC_12: '',

        inputD_1: '',
        inputD_2: '',
        inputD_3: '',
        inputD_4: '',
        inputD_5: '',
        inputD_6: '',
        inputD_7: '',
        inputD_8: '',
        inputD_9: '',
        inputD_10: '',
        inputD_11: '',
        inputD_12: '',

        inputE_1: '',
        inputE_2: '',
        inputE_3: '',
        inputE_4: '',
        inputE_5: '',
        inputE_6: '',
        inputE_7: '',
        inputE_8: '',
        inputE_9: '',
        inputE_10: '',
        inputE_11: '',
        inputE_12: '',

        fileList: [],
        companyName:'',
      },
    }
  },
  methods: {
    targetCompany (value) {
      this.form.companyName = value.com_name
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
}
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.input-se {
  width: 100%;
  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }
  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 20px !important;
  }
  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;
    position: relative;
    &::before {
      content: "~";
      width: 10px;
      position: absolute;
      left: -15px;
      text-align: center;
    }
  }
  &::v-deep .inline-block {
    width: 100% !important;
  }
}
</style>
